<template>
  <div class="pre_list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" :label-width="labelWidth">
        <!-- 反馈单号 -->
        <el-form-item :label="$t('zlfk.fkdh') + ':'">
          <el-input
            v-model="queryParams.feedbackFormId"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item :label="$t('home.carType') + ':'">
          <el-select filterable clearable v-model="queryParams.carModel">
            <el-option
              v-for="item in carTypeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- VIN -->
        <el-form-item label="VIN:">
          <el-input
            v-model="queryParams.vin"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item :label="$t('climant.status') + ':'">
          <el-select v-model="queryParams.status" filterable clearable>
            <el-option :label="$t('climant.noSubmit')" :value="0"></el-option>
            <el-option :label="$t('zlfk.clz')" :value="1"></el-option>
            <el-option :label="$t('zlfk.ywc')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item :label="$t('zlfk.lztype') + ':'">
          <el-select v-model="queryParams.componentCategory" filterable clearable>
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get($i18n.locale)]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 故障现象描述 -->
        <el-form-item :label="$t('restockInfo.gzxxms') + ':'">
          <el-input
            v-model="queryParams.questionContent"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 提交时间 -->
        <el-form-item :label="$t('zlfk.tjsj') + ':'">
          <el-date-picker
            v-model="queryParams.submitTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
          <!-- 最后更新时间 -->
        <el-form-item :label="$t('zlfk.zhgxsj')+ ':'">
          <el-date-picker
            v-model="queryParams.updateTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div>
          <el-button class="primary-btn" icon="el-icon-plus" type="primary" @click="handleAddOrEditOrLook({}, 'add')">
            {{ $t("zlfk.xzfkd") }}
          </el-button>
          <el-button class="primary-btn"  plain icon="el-icon-download" type="primary"  @click="handleExport">
            {{ $t("cart.export") }}
          </el-button>
        </div>

        <div>
          <el-button class="primary-btn" type="primary" @click="doSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <el-table
        ref="tableRef"
        stripe
        border
        highlight-current-row
        :data="tableData"
        :max-height="maxHeight"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('cart.xh')"
          width="60px"
          align="center"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 反馈单号 -->
        <el-table-column
          property="feedbackFormId"
          :label="$t('zlfk.fkdh')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <div
              class="lineTheme"
              @click="handleAddOrEditOrLook(scope.row, 'look')"
            >{{ scope.row.feedbackFormId}}</div>
          </template>
        </el-table-column>
        <!-- 车型 -->
        <el-table-column
          property="carModel"
          :label="$t('home.carType')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- VIN码 -->
        <el-table-column
          property="vin"
          :label="$t('zlfk.vin')"
          min-width="180px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 反馈问题 -->
        <el-table-column
          property="questionTotal"
          :label="$t('zlfk.fkwt')"
          min-width="90px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 被驳回 -->
        <el-table-column
          :label="$t('zlfk.bbh')"
          min-width="90px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span
              :class="{ active: scope.row.rejectTotal !== 0 }"
              @click="
                scope.row.rejectTotal !== 0 &&
                  handleAddOrEditOrLook(scope.row, 'look', 3)
              "
              >{{ scope.row.rejectTotal }}</span
            >
          </template>
        </el-table-column>
        <!-- 处理中 -->
        <el-table-column
          property="ingTotal"
          :label="$t('zlfk.clz')"
          min-width="90px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 待确认 -->
        <el-table-column
          :label="$t('zlfk.dqr')"
          min-width="90px"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span
              :class="{ active: scope.row.waitingTotal !== 0 }"
              @click="
                scope.row.waitingTotal !== 0 &&
                  handleAddOrEditOrLook(scope.row, 'look', 2)
              "
              >{{ scope.row.waitingTotal }}</span
            >
          </template>
        </el-table-column>
        <!-- 已关闭 -->
        <el-table-column
          property="closeTotal"
          :label="$t('home.closed')"
          min-width="90px"
          align="center"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          property="status"
          :label="$t('climant.status')"
          width="125px"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <div class="statusDetail" v-if="scope.row.status === 0">
              <img src="@/assets/image/draft.png" alt="">
              <span>{{ $t("climant.noSubmit") }}</span>
            </div>
            <div class="statusDetail" v-if="scope.row.status === 1">
              <img src="@/assets/image/submitted.png" alt="">
              <span>{{ $t("zlfk.clz") }}</span>
            </div>
            <div class="statusDetail" v-if="scope.row.status === 2">
              <img src="@/assets/image/completed.png" alt="">
              <span>{{ $t("home.closed") }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column
          property="creator"
          :label="$t('zlfk.cjr')"
          min-width="120px"
          :render-header="$globalRenderHeader"
        >
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column
          property="createTime"
          :label="$t('zlfk.cjsj')"
          width="160"
         :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 提交时间 -->
        <el-table-column
          property="submitTime"
          :label="$t('zlfk.tjsj')"
          width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 最后更新时间 -->
        <el-table-column
          property="updateTime"
          :label="$t('zlfk.zhgxsj')"
          width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          :render-header="$globalRenderHeader"
          :width="{'ru': 280, 'en': 165, 'vi': 185, 'es':175} [$i18n.locale] || 150"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              type="text"
              @click="handleAddOrEditOrLook(scope.row, 'look')"
              >
                {{
                  scope.row.rejectTotal > 0 || scope.row.waitingTotal > 0
                    ? $t("restockInfo.process")
                    : $t("operate.view")
                }}
            </el-button>
            <!-- 编辑 -->
            <el-button
              v-if="scope.row.status === 0"
              type="text"
              @click="handleAddOrEditOrLook(scope.row, 'edit')"
              >{{ $t("home.edit") }}</el-button
            >
            <!-- 提交 -->
            <el-button
              v-if="scope.row.status === 0 && scope.row.questionTotal !== 0"
              type="text"
              @click="handleChangeStatus(scope.row, 'zlfk.submitZlfk')"
              >{{ $t("seek.submit") }}</el-button
            >
            <!-- 删除 -->
            <el-button
              v-if="scope.row.questionTotal === 0"
              type="text"
              @click="handleChangeStatus(scope.row, 'zlfk.deleteZlfk')"
              > {{ $t("cart.delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="total > 0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import listCurd from '@/mixins/listCurd'
import { setStorageNew } from '@/util/localStor'
import { preAfterSalesListApi, preAfterSubmitApi, exportFeedback, deleteEmptyFormApi } from '@/api/feedback'
import { getDownloadFiles } from '@/util/downFile'
import { getDictItem } from '@/util/dict'
import faultData from '@/mixins/faultData'
export default {
  mixins: [listCurd, faultData],
  data () {
    return {
      maxHeight:　null,
      carTypeList: [], // 车型
      queryParams: {
        carType: 1,
        feedbackFormId: '',
        carModel: '',
        vin: '',
        status: '',
        submitTime: '',
        updateTime: '',
        componentCategory: '',
        questionContent: ''
      }, // 查询参数
      type: 'afterSales',
      listMethod: preAfterSalesListApi // 获取表格数据api
    }
  },
  computed: {
    labelWidth () {
      const widthMap = {
        zh: '100px',
        en: '235px',
        ru: '275px',
        fa: '125px',
        vi: '160px',
        es: '280px'
      }
      return widthMap[this.$i18n.locale] || '150px'
    }
  },
  watch: {
    // // 切换语言更新表格视图
    // "$i18n.locale"() {
    //   this.$nextTick(() => {
    //     if (this.$refs.tableRef) {
    //       this.$refs.tableRef.doLayout();
    //     }
    //   })
    // }
  },
  created () {
    this.removeItem('afterSalesDetail')
    // 获取车型列表
    this.getCarTypeList()
    // 获取表格数据
    this.getList()
    this.getTypeList()
  },
  methods: {
    // 查询参数
    getParams () {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) }
      if ((params.submitTime || []).length === 2) {
        params.submitTimeStart = params.submitTime?.[0]
        params.submitTimeEnd = params.submitTime?.[1]
      }
      // delete params.submitTime;
      if ((params.updateTime || []).length === 2) {
        params.updateTimeStart = params.updateTime?.[0]
        params.updateTimeEnd = params.updateTime?.[1]
      }
      // delete params.updateTime;
      return {
        data: {
          ...params
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }
    },
    // 获取车型列表
    async getCarTypeList () {
      try {
        const carTypeList = (await getDictItem('carType')) || []
        carTypeList.map((item) => {
          this.carTypeList.push({ text: item.value, value: item.code })
        })
      } catch (error) {
        console.error("获取车辆类型失败:", error);
      }
    },
    // (新增 | 编辑 | 查看)反馈单
    handleAddOrEditOrLook (data = {}, operate, status) {
      setStorageNew('qualityData', data)
      this.getSetItem()
      this.$router.push({
        path: '/qualityNew/afterSalesDetail',
        query: {
          operate,
          status
        }
      })
    },
    /**
     * 导出质量反馈列表
     */
    async handleExport () {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) }
      if ((params.submitTime || []).length === 2) {
        params.submitTimeStart = params.submitTime?.[0]
        params.submitTimeEnd = params.submitTime?.[1]
      }
      if ((params.updateTime || []).length === 2) {
        params.updateTimeStart = params.updateTime?.[0]
        params.updateTimeEnd = params.updateTime?.[1]
      }
      const query = {
        data: {
          ...params,
          languageType: this.$i18n.locale
        }
      }
      const res = await exportFeedback(query)
      getDownloadFiles(res)
      if (res.fileName) {
        this.$DonMessage.success(this.$t('request.exportOrder'))
      }
    },
    // （提交 | 删除）反馈单
    async handleChangeStatus (row, title) {
      this.getSetItem()
      await this.$confirm(
        `${this.$t(title) + ':' + row.feedbackFormId}?`,
        this.$t('request.tips'),
        {
          cancelButtonClass: 'confirm-btn-close',
          confirmButtonClass: 'confirm-btn-confirm',
          type: 'warning'
        }
      )
      var res = {}
      if (title === 'zlfk.submitZlfk') {
        res = await preAfterSubmitApi({
          data: {
            feedbackFormId: row.feedbackFormId,
            createTime: row.createTime
          }
        })
      } else if (title === 'zlfk.deleteZlfk') {
        res = await deleteEmptyFormApi(row.feedbackFormId)
      }
      if (res.status == 0) {
        this.$DonMessage.success(this.$t('message.czcg'))
        this.getList()
      } else {
        this.$DonMessage.error(res.message)
      }
    }
  }
}
</script>
